import { useEffect, useRef, useState } from "react"


import cassi from "../../../assets/general_assets/cassi.jpg"

export default function SubTeacherRender() {

    const [currentIndex, setCurrentIndex] = useState(0)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 450)


    const cassiRef = useRef(null)

    const subTeacherCards = [
        {
            nome: "Cassi",
            card: cassi,
            referencia: cassiRef,
        }

    ]

    const showCard = (index) => {
        setCurrentIndex(index)
    }

    function nextImg() {
        const newIndex = (currentIndex + 1) % subTeacherCards.length
        showCard(newIndex);

    }

    function prevImg() {
        const newIndex = (currentIndex - 1 + subTeacherCards.length) % subTeacherCards.length
        showCard(newIndex);
    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 450);
        };

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);



    return (
        <>
            {isMobile ? (

                <div className="sub_teachers">
                    {subTeacherCards.map((subTeacher, index) => (

                        <div key={index} ref={(el) => subTeacher.referencia = el} className={`sub_teacher_card ${index === currentIndex ? "active" : ""}`}>

                            
                            <img src={subTeacher.card} alt="Imagem Professor Team Crezio" loading="lazy"></img>
                            <p className="sub_teacher_card_name">{subTeacher.nome}</p>

                        </div>


                    ))}

                </div>
            ) : (

                <div className="sub_teachers">
                {subTeacherCards.map((subTeacher) => (

                        <div ref={subTeacher.referencia} className="sub_teacher_card">

                        <img src={subTeacher.card} alt="Imagem Professor Team Crezio" loading="lazy"></img>
                        <p className="sub_teacher_card_name">{subTeacher.nome}</p>

                        </div>
                        
                    ))}
                </div>
            )}
        </>
    )
}
